<div class="layout-menu-profile">
    <button class="p-link border-noround" (click)="toggleMenu()" pTooltip="Profile"
        [tooltipDisabled]="isTooltipDisabled">
        <!-- <img src="assets/demo/images/avatar/amyelsner.png" alt="avatar" style="width: 32px; height: 32px;"> -->
        <div style="width: 32px; height: 32px; border-radius: 50%; overflow: hidden; flex-shrink: 0;" *ngIf="shouldShowUserImage; else avatarInicial">
            <img [src]="user.url_imagem_usuario" alt="Avatar" style="width: 100%; height: 100%; object-fit: cover; display: block;" (error)="onUserImageError()">
        </div>
        <ng-template #avatarInicial>
            <div style="display: flex; align-items: center; justify-content: center; color: white; font-weight: bold; width: 32px; height: 32px; border-radius: 50%; font-size: 14px; text-transform: uppercase;" [style.background-color]="getRandomColor()">
                {{ getInitial(user.name) }}
            </div>
        </ng-template>
        <span>
            <strong>{{user.name}}</strong>
            <small>{{user.email}}</small>
        </span>
        <i class="layout-menu-profile-toggler pi pi-fw"
            [ngClass]="{'pi-angle-down': menuProfilePosition === 'start' || isHorizontal, 'pi-angle-up': menuProfilePosition === 'end' && !isHorizontal}"></i>
    </button>

    <ul *ngIf="menuProfileActive" [@menu]="isHorizontal ? 'overlay' : 'inline'">
        <li pTooltip="Alterar dados do Usuário" [tooltipDisabled]="isTooltipDisabled" (click)="changePassword()">
            <button class="p-link">
                <i class="pi pi-key pi-fw"></i>
                <span>Alterar dados do Usuário</span>
            </button>
        </li>
        <li pTooltip="Sair" [tooltipDisabled]="isTooltipDisabled" (click)="logout()">
            <button class="p-link">
                <i class="pi pi-power-off pi-fw"></i>
                <span>Sair</span>
            </button>
        </li>
    </ul>
</div>

<p-dialog header="Alterar dados do Usuário" appendTo="body" [(visible)]="displayModal" [modal]="true"
    [breakpoints]="{'960px': '85vw', '640px': '95vw'}" [style]="{width: '42rem'}" [baseZIndex]="10000"
    [draggable]="false" [resizable]="false" styleClass="profile-edit-dialog">
    <div class="profile-dialog-body">
        <form [formGroup]="form" class="p-fluid">
            <div class="profile-dialog-layout">
                <div class="profile-fields">
                    <section class="profile-section">
                        <h6 class="profile-section-title">Dados pessoais</h6>

                        <div class="field">
                            <p-floatlabel>
                                <input type="text" id="name" pInputText formControlName="name">
                                <label for="name">Nome</label>
                            </p-floatlabel>
                            <small id="nome-help" *ngIf="form.get('name').invalid" class="p-error">Nome é obrigatório.</small>
                        </div>

                        <div class="field">
                            <p-floatlabel>
                                <input type="text" id="email" pInputText [value]="user.email" readonly tabindex="-1">
                                <label for="email">E-mail</label>
                            </p-floatlabel>
                        </div>
                    </section>

                    <section class="profile-section">
                        <h6 class="profile-section-title">Segurança</h6>
                        <p class="profile-section-hint">Deixe em branco para manter a senha atual.</p>

                        <div class="field">
                            <p-floatlabel>
                                <input type="password" id="password" pInputText formControlName="password">
                                <label for="password">Nova senha</label>
                            </p-floatlabel>
                        </div>

                        <div class="field" *ngIf="shouldShowPasswordConfirmation">
                            <p-floatlabel>
                                <input type="password" id="current_password" pInputText formControlName="current_password">
                                <label for="current_password">Senha atual</label>
                            </p-floatlabel>
                        </div>

                        <div class="field" *ngIf="shouldShowPasswordConfirmation">
                            <p-floatlabel>
                                <input type="password" id="password_confirmation" pInputText formControlName="password_confirmation">
                                <label for="password_confirmation">Confirmar nova senha</label>
                            </p-floatlabel>
                        </div>
                    </section>
                </div>

                <div class="profile-avatar-section">
                    <span class="avatar-label">Foto do perfil</span>
                    <div class="avatar-container">
                        <div class="avatar-wrapper">
                            <img [src]="profileAvatarSrc"
                                 alt="Foto do perfil"
                                 class="avatar-img"
                                 (error)="onProfilePreviewImageError($event)">
                            <label for="profile-image-upload" class="avatar-overlay" title="Alterar foto">
                                <i class="pi pi-camera"></i>
                            </label>
                            <input #profileImageUpload id="profile-image-upload" type="file" accept="image/*"
                                   (change)="onProfileImageSelected($event)" style="display: none;">
                        </div>
                        <button *ngIf="hasProfileImage"
                                type="button"
                                class="avatar-clear-btn"
                                title="Remover foto"
                                (click)="clearImage()">
                            <i class="pi pi-times"></i>
                        </button>
                    </div>
                    <span class="avatar-hint">
                        {{ hasProfileImage ? 'Clique para alterar' : 'Clique para adicionar' }}
                    </span>
                </div>
            </div>
        </form>
    </div>
    <ng-template pTemplate="footer">
        <div class="profile-dialog-footer">
            <button pButton pRipple type="button" icon="pi pi-times" (click)="displayModal = false" label="Cancelar"
                class="p-button-text p-button-secondary">
            </button>
            <button *ngIf="!loading"
                [disabled]="form.invalid"
                pButton pRipple type="button" icon="pi pi-check" (click)="save()" label="Salvar"
                class="p-button-raised p-button-success">
            </button>
            <p-progressSpinner *ngIf="loading" [style]="{width: '2rem', height: '2rem'}" styleClass="custom-spinner"
                strokeWidth="6" animationDuration=".5s">
            </p-progressSpinner>
        </div>
    </ng-template>
</p-dialog>
